<div class="step-container">
  <h2 class="step-title">Número de celular</h2>
  <p class="step-subtitle">Ingrese su número de celular. Le enviaremos un código de verificación por SMS.</p>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="step-form">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Número de celular</mat-label>
      <input
        matInput
        formControlName="phone"
        type="tel"
        placeholder="Ej: 1155667788"
        inputmode="tel"
        autocomplete="tel" />
      <mat-icon matPrefix>phone</mat-icon>
      <mat-error *ngIf="form.get('phone')?.hasError('required')">
        El número de celular es obligatorio.
      </mat-error>
      <mat-error *ngIf="form.get('phone')?.hasError('pattern')">
        Ingrese un número de celular argentino válido.
      </mat-error>
    </mat-form-field>

    <div *ngIf="errorMessage" class="error-message">
      <mat-icon>error_outline</mat-icon>
      <span>{{ errorMessage }}</span>
    </div>

    <button
      mat-raised-button
      color="primary"
      class="action-button"
      type="submit"
      [disabled]="loading">
      <mat-spinner *ngIf="loading" diameter="24" class="button-spinner"></mat-spinner>
      <span *ngIf="!loading">Enviar código</span>
    </button>
  </form>
</div>
